// extracted by mini-css-extract-plugin
export default {"root":"PreCheckCard_root__nRaPN","title":"PreCheckCard_title__wzFzn"};